import { handleKeyDown } from "_services";
import { useState, useEffect } from "react";
import './loadingChalli.css';

const LoadingChalli = ({ values = [], onChange, mandatory = 0, disabled = false }) => {
  const [inputValues, setInputValues] = useState(() => {
    const initialValues = [...values];
    while (initialValues.length < 20) {
      initialValues.push("");
    }
    return initialValues.slice(0, 20);
  });

  const [isInitialized, setIsInitialized] = useState(false);

  // Calculate total
  const total = inputValues.reduce((sum, value) => {
    const num = parseFloat(value) || 0;
    return sum + num;
  }, 0);

  const handleInputChange = (index, value) => {
    const newValues = [...inputValues];
    newValues[index] = value;
    setInputValues(newValues);

    // Always send to parent: all 20 values + total as 21st item
    if (onChange) {
      const newTotal = newValues.reduce((sum, val) => {
        const num = parseFloat(val) || 0;
        return sum + num;
      }, 0);
      onChange([...newValues, newTotal.toString()]); // [v1, v2, ..., v20, "total"]
    }
  };

  useEffect(() => {
    if (!isInitialized && values.length > 0) {
      const newValues = [...values];
      while (newValues.length < 20) {
        newValues.push("");
      }
      setInputValues(newValues.slice(0, 20));
      setIsInitialized(true);

      // Also notify parent with initial total
      if (onChange) {
        const initialTotal = newValues.reduce((sum, val) => {
          const num = parseFloat(val) || 0;
          return sum + num;
        }, 0);
        onChange([...newValues, initialTotal.toString()]);
      }
    }
  }, [values, isInitialized]);

  return (
    <div className="__loadingChalli_main" style={{maxWidth:'1160px'}}>
      {/* First Table: 1-10 */}
      <table>
        <thead>
          <tr>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {inputValues.slice(0, 10).map((value, index) => (
              <td key={index}>
                <input
                  className="__challiInput"
                  type="text"
                  value={value}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                    const truncatedValue = numericValue.slice(0, 5);
                    handleInputChange(index, truncatedValue);
                  }}
                  disabled={disabled}
                  onKeyDown={handleKeyDown}
                  maxLength={5}
                />
              </td>
            ))}
          </tr>
        </tbody>
      </table>

      {/* Second Table: 11-20 */}
      <table>
        <thead>
          <tr>
            <th>11</th>
            <th>12</th>
            <th>13</th>
            <th>14</th>
            <th>15</th>
            <th>16</th>
            <th>17</th>
            <th>18</th>
            <th>19</th>
            <th>20</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {inputValues.slice(10, 20).map((value, index) => (
              <td key={index + 10}>
                <input
                  className="__challiInput"
                  type="text"
                  value={value}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                    const truncatedValue = numericValue.slice(0, 5);
                    handleInputChange(index + 10, truncatedValue);
                  }}
                  disabled={disabled}
                  onKeyDown={handleKeyDown}
                  maxLength={5}
                />
              </td>
            ))}
          </tr>
        </tbody>
      </table>

      {/* No total shown here — parent handles it */}
    </div>
  );
};

export default LoadingChalli;